/* ==========================================================================
   Bewertungsseite: lädt alle Bewertungen aus Fera, mischt die eigenen
   Kundenmeinungen aus dem Theme-Editor dazu und baut Filter und Karten (Raster).
   Alle Texte werden als Text eingesetzt (kein HTML aus Bewertungen).
   ========================================================================== */
(function () {
  var KEY = 'pk_fa78d17236253efa8418bf77762e29c7a76ca471558e34180e13bbb8319ad8c5';
  var API = 'https://api.fera.ai/v2/public/reviews.json?public_key=' + KEY + '&limit=100';
  var PRO_SEITE = 24;
  var QUELLEN = { instagram: 'via Instagram', email: 'per E-Mail', whatsapp: 'per WhatsApp', sonstiges: 'Kundenmeinung' };

  var root = document.querySelector('[data-bwt]');
  if (!root) return;
  var $ = function (sel) { return root.querySelector(sel); };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function entity(s) { return String(s || '').replace(/&euro;/g, '€').replace(/&nbsp;/g, ' ').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&'); }
  function pfad(u) { return String(u || '').replace(/^https?:\/\/[^/]+/, ''); }
  function sterne(n) { n = Math.round(n || 0); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
  function monat(d) { return d && !isNaN(d) ? d.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' }) : ''; }
  function kurzname(n) { return entity(n).split(' | ')[0]; }
  // Fera-Originale sind 3–6 MB groß; media.fera.ai liefert sie in passender Breite (~90 KB bei 800 px).
  function bildUrl(u, breite) {
    if (!/app-uploads-cdn\.fera\.ai/.test(u)) return u;
    return u.replace('app-uploads-cdn.fera.ai', 'media.fera.ai').split('?')[0] + '?width=' + breite;
  }
  function bildSetzen(img, u, breite) {
    img.addEventListener('load', function () { img.classList.add('is-da'); });
    img.addEventListener('error', function () { if (img.src !== u) img.src = u; }, { once: true });
    img.src = bildUrl(u, breite);
  }

  function kategorie(name) {
    var n = (name || '').toLowerCase(), t = [];
    if (/willkommens|begrüßung|stoffbanner/.test(n)) t.push('schild');
    if (/tischnummer/.test(n)) t.push('tisch');
    if (/topper|cake charm|tortenschild|tortenaufsteller/.test(n)) t.push('topper');
    return t;
  }

  /* ---- Daten ----
     Alle Pakete (je 100) werden gleichzeitig angefragt. Sobald Paket 1 da ist (neueste 100),
     zeigt die Seite schon die ersten Karten; der Rest kommt im Hintergrund dazu.
     Pro Browser-Sitzung wird das Ergebnis 30 Minuten zwischengespeichert. */
  var CACHE = 'bwt-fera-v1', CACHE_MIN = 30;
  function schlankFera(r) {
    return { customer_name: r.customer_name, heading: r.heading, body: r.body, rating: r.rating, date: r.date || r.created_at,
      photos: r.photos || [], product: r.product ? { name: r.product.name, url: r.product.url } : null, store_reply: r.store_reply };
  }
  function seite(p, versuch) {
    return fetch(API + '&page=' + p).then(function (res) {
      if (!res.ok) throw new Error(res.status);
      var gesamt = parseInt(res.headers.get('total-count'), 10) || 0;
      return res.json().then(function (d) { return { gesamt: gesamt, daten: Array.isArray(d) ? d : [] }; });
    }).catch(function () {
      // Ein zweiter Versuch nach kurzer Pause, dann aufgeben (Rest der Seite funktioniert trotzdem).
      if (versuch) return { gesamt: 0, daten: [], fehler: true };
      return new Promise(function (ok) { setTimeout(ok, 800); }).then(function () { return seite(p, true); });
    });
  }
  function feraLaden(beiErstem) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE) || 'null');
      if (c && Date.now() - c.zeit < CACHE_MIN * 60000) return Promise.resolve(c.daten);
    } catch (e) {}
    var anfragen = [1, 2, 3, 4].map(function (p) { return seite(p); });
    anfragen[0].then(function (r) { if (r.daten.length) beiErstem(r.daten, r.gesamt); });
    return Promise.all(anfragen).then(function (teile) {
      var gesamt = teile[0].gesamt, extra = [];
      for (var p = 5; p <= Math.ceil(gesamt / 100); p++) extra.push(seite(p));
      return Promise.all(extra).then(function (rest) {
        var daten = [].concat.apply([], teile.concat(rest).map(function (t) { return t.daten; })).map(schlankFera);
        // Nur ein vollständiges Ergebnis zwischenspeichern – sonst beim nächsten Aufruf neu laden.
        if (gesamt && daten.length >= gesamt) {
          try { sessionStorage.setItem(CACHE, JSON.stringify({ zeit: Date.now(), daten: daten })); } catch (e) {}
        }
        return daten;
      });
    });
  }

  function vonFera(r) {
    var prod = r.product || null;
    var fotos = (r.photos || []).filter(Boolean);
    return {
      typ: 'fera',
      quelle: 'Verifizierter Kauf',
      name: r.customer_name || 'Kundin',
      titel: entity(r.heading),
      text: entity(r.body),
      sterne: r.rating || 5,
      datum: new Date(r.date || r.created_at),
      bild: fotos[0] || '',
      bildAlt: 'Kundenfoto von ' + (r.customer_name || 'einer Kundin'),
      produkt: prod ? { name: kurzname(prod.name), url: prod.url ? pfad(prod.url) : '' } : null,
      antwort: entity(r.store_reply),
      tags: (fotos.length ? ['fotos'] : []).concat(kategorie(prod && prod.name))
    };
  }

  function vonEigen(e) {
    var teile = String(e.datum || '').split('.');
    var d = teile.length === 3 ? new Date(+teile[2], +teile[1] - 1, +teile[0]) : new Date(0);
    var prod = e.produkt ? { name: kurzname(e.produkt.name), url: e.produkt.url, preis: e.produkt.preis, bild: e.produkt.bild } : null;
    return {
      typ: e.quelle || 'sonstiges',
      quelle: QUELLEN[e.quelle] || 'Kundenmeinung',
      name: e.name || '',
      titel: e.titel || '',
      text: e.text || '',
      sterne: e.sterne || 5,
      datum: d,
      bild: e.bild ? (e.bild.indexOf('//') === 0 ? 'https:' + e.bild : e.bild) : '',
      bildAlt: e.bildAlt || e.name || 'Kundenfoto',
      link: e.link || '',
      produkt: prod,
      punkt: prod && e.bild ? { x: e.x, y: e.y } : null,
      tags: [e.quelle].concat(e.bild ? ['fotos'] : []).concat(kategorie(prod && prod.name)),
      eigen: true
    };
  }

  /* ---- Statistik ---- */
  function statistik(liste) {
    var z = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, summe = 0;
    liste.forEach(function (r) { var s = Math.max(1, Math.min(5, Math.round(r.sterne))); z[s]++; summe += r.sterne; });
    var n = liste.length || 1;
    $('[data-bwt-schnitt]').textContent = (Math.round((summe / n) * 10) / 10).toFixed(1).replace('.', ',');
    $('[data-bwt-anzahl]').textContent = liste.length.toLocaleString('de-DE');
    for (var s = 1; s <= 5; s++) {
      root.querySelector('[data-bwt-bar="' + s + '"]').style.width = Math.round((z[s] / n) * 100) + '%';
      root.querySelector('[data-bwt-barn="' + s + '"]').textContent = z[s];
    }
  }

  /* ---- Großansicht ---- */
  var dialog = $('[data-bwt-dialog]');
  function zeigeGross(r) {
    var inhalt = $('[data-bwt-dialog-inhalt]');
    inhalt.textContent = '';
    var img = el('img'); img.alt = r.bildAlt; bildSetzen(img, r.bild, 1400); inhalt.appendChild(img);
    var t = el('div', 'bwt__dialog-text');
    t.appendChild(el('span', 'bwt__karte-sterne', sterne(r.sterne)));
    if (r.titel) t.appendChild(el('p', 'bwt__karte-titel', r.titel));
    if (r.text) t.appendChild(el('p', 'bwt__karte-text', r.text));
    t.appendChild(fuss(r));
    inhalt.appendChild(t);
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
  }
  $('[data-bwt-zu]').addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  /* ---- Produkt-Punkt auf eigenen Fotos ---- */
  function punktSetzen(box, r) {
    var karte = el('div', 'bwt__pkarte'); karte.hidden = true;
    karte.id = 'bwt-p-' + Math.random().toString(36).slice(2);
    karte.style.top = 'calc(' + Math.min(r.punkt.y, 70) + '% + 30px)';
    if (r.produkt.bild) { var pi = el('img'); pi.src = r.produkt.bild; pi.alt = ''; karte.appendChild(pi); }
    var kt = el('div', 'bwt__pkarte-t');
    kt.appendChild(el('span', 'bwt__pkarte-n', r.produkt.name));
    if (r.produkt.preis) kt.appendChild(el('span', 'bwt__pkarte-p', 'ab ' + r.produkt.preis));
    var a = el('a', '', 'Zum Produkt'); a.href = r.produkt.url; kt.appendChild(a);
    karte.appendChild(kt);
    var p = el('button', 'bwt__punkt'); p.type = 'button';
    p.style.left = r.punkt.x + '%'; p.style.top = r.punkt.y + '%';
    p.setAttribute('aria-label', 'Produkt anzeigen: ' + r.produkt.name);
    p.setAttribute('aria-expanded', 'false');
    p.setAttribute('aria-controls', karte.id);
    p.addEventListener('click', function (e) {
      e.stopPropagation();
      var auf = karte.hidden;
      root.querySelectorAll('.bwt__pkarte').forEach(function (k) { k.hidden = true; });
      root.querySelectorAll('.bwt__punkt').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      karte.hidden = !auf;
      p.setAttribute('aria-expanded', String(auf));
    });
    box.appendChild(p);
    box.appendChild(karte);
  }

  /* ---- Karten ---- */
  function fuss(r) {
    var f = el('div', 'bwt__karte-fuss');
    var z = el('span'); z.appendChild(el('strong', '', r.name));
    var m = monat(r.datum); if (m && r.datum.getFullYear() > 2000) z.appendChild(document.createTextNode(' · ' + m));
    f.appendChild(z);
    if (r.produkt && r.produkt.url) { var a = el('a', '', r.produkt.name + ' →'); a.href = r.produkt.url; f.appendChild(a); }
    else if (r.produkt) f.appendChild(el('span', '', r.produkt.name));
    if (r.link) { var l = el('a', '', 'Original ansehen'); l.href = r.link; l.target = '_blank'; l.rel = 'noopener'; f.appendChild(l); }
    return f;
  }

  function karte(r) {
    var k = el('article', 'bwt__karte');
    var kopf = el('div', 'bwt__karte-kopf');
    var st = el('span', 'bwt__karte-sterne', sterne(r.sterne)); st.setAttribute('aria-label', Math.round(r.sterne) + ' von 5 Sternen');
    kopf.appendChild(st);
    kopf.appendChild(el('span', 'bwt__badge bwt__badge--' + r.typ, r.quelle));
    k.appendChild(kopf);
    if (r.bild) {
      var box = el('div', 'bwt__bildbox');
      var b = el('button', 'bwt__karte-bild'); b.type = 'button'; b.setAttribute('aria-label', 'Foto groß ansehen: ' + r.name);
      var img = el('img'); img.alt = r.bildAlt; img.loading = 'lazy'; bildSetzen(img, r.bild, 700); b.appendChild(img);
      b.addEventListener('click', function () { zeigeGross(r); });
      box.appendChild(b);
      if (r.punkt && r.produkt && r.produkt.url) punktSetzen(box, r);
      k.appendChild(box);
    }
    if (r.titel) k.appendChild(el('p', 'bwt__karte-titel', r.titel));
    if (r.text) k.appendChild(el('p', 'bwt__karte-text', r.text));
    if (r.antwort) { var an = el('p', 'bwt__antwort'); an.appendChild(el('strong', '', 'Antwort von Schöne Deko')); an.appendChild(document.createTextNode(r.antwort)); k.appendChild(an); }
    k.appendChild(fuss(r));
    return k;
  }

  /* Masonry: Spalten je nach Breite, jede Karte in die gerade kürzeste Spalte */
  var spalten = [];
  function spaltenZahl() { var w = $('[data-bwt-karten]').clientWidth; return w >= 1000 ? 3 : w >= 640 ? 2 : 1; }
  function spaltenBauen() {
    var box = $('[data-bwt-karten]'), n = spaltenZahl();
    box.textContent = ''; spalten = [];
    for (var i = 0; i < n; i++) { var sp = el('div', 'bwt__spalte'); box.appendChild(sp); spalten.push(sp); }
  }
  function einsetzen(k) {
    var kurz = spalten[0];
    spalten.forEach(function (sp) { if (sp.offsetHeight < kurz.offsetHeight) kurz = sp; });
    kurz.appendChild(k);
  }

  var alle = [], gefiltert = [], gezeigt = 0, filter = 'alle';
  function zeigen(neu, bis) {
    if (neu) { spaltenBauen(); gezeigt = 0; }
    var ende = bis || gezeigt + PRO_SEITE;
    gefiltert.slice(gezeigt, ende).forEach(function (r) { einsetzen(karte(r)); });
    gezeigt = Math.min(ende, gefiltert.length);
    $('[data-bwt-mehr]').hidden = gezeigt >= gefiltert.length;
    $('[data-bwt-treffer]').textContent = gefiltert.length.toLocaleString('de-DE') + (filter === 'alle' ? ' Bewertungen · neueste zuerst' : ' Treffer');
  }
  function filtern(f) {
    filter = f;
    gefiltert = f === 'alle' ? alle : alle.filter(function (r) { return r.tags.indexOf(f) > -1; });
    root.querySelectorAll('.bwt__chip').forEach(function (c) { var an = c.dataset.filter === f; c.classList.toggle('is-aktiv', an); c.setAttribute('aria-pressed', String(an)); });
    zeigen(true);
  }

  /* ---- Start ---- */
  var eigene = [];
  try { eigene = JSON.parse($('[data-bwt-eigene]').textContent || '[]').filter(function (e) { return e.text || e.bild; }).map(vonEigen); } catch (e) {}

  $('[data-bwt-chips]').addEventListener('click', function (e) { var c = e.target.closest('.bwt__chip'); if (c) filtern(c.dataset.filter); });
  $('[data-bwt-mehr]').addEventListener('click', function () { zeigen(false); });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bwt__bildbox')) root.querySelectorAll('.bwt__pkarte').forEach(function (k) { k.hidden = true; });
  });
  // „Bewertung schreiben“ öffnet das eigene Popup (snippets/bewertung-schreiben.liquid).

  window.addEventListener('resize', function () {
    if (!gefiltert.length || spalten.length === spaltenZahl()) return;
    var n = gezeigt; zeigen(true, n);
  });

  function quellenChips() {
    ['instagram', 'email'].forEach(function (q) {
      if (alle.some(function (r) { return r.typ === q; })) root.querySelector('[data-filter="' + q + '"]').hidden = false;
    });
  }
  function fertigLaden() {
    root.classList.remove('is-laedt');
    $('[data-bwt-status]').hidden = true;
  }
  function mischen(fera) { return fera.map(vonFera).concat(eigene).sort(function (a, b) { return b.datum - a.datum; }); }

  var schonGezeigt = false;
  feraLaden(function (erste, gesamt) {
    // Paket 1 ist da: die neuesten Karten sofort zeigen.
    alle = mischen(erste);
    $('[data-bwt-anzahl]').textContent = (gesamt + eigene.length).toLocaleString('de-DE');
    quellenChips(); fertigLaden(); filtern('alle');
    schonGezeigt = true;
  }).catch(function () { return []; }).then(function (fera) {
    alle = mischen(fera);
    fertigLaden();
    if (!alle.length) { $('[data-bwt-status]').hidden = false; $('[data-bwt-status]').textContent = 'Die Bewertungen konnten gerade nicht geladen werden. Bitte lade die Seite neu.'; return; }
    statistik(alle);
    quellenChips();
    if (!schonGezeigt) { filtern('alle'); return; }
    // Alles da: Liste ergänzen, ohne die sichtbaren Karten neu aufzubauen (neueste stehen schon oben).
    gefiltert = filter === 'alle' ? alle : alle.filter(function (r) { return r.tags.indexOf(filter) > -1; });
    $('[data-bwt-mehr]').hidden = gezeigt >= gefiltert.length;
    $('[data-bwt-treffer]').textContent = gefiltert.length.toLocaleString('de-DE') + (filter === 'alle' ? ' Bewertungen · neueste zuerst' : ' Treffer');
  });
})();
